<template>
	<div class="ms-cell-editor" :class="[`ms-text-${col.align}`]">
		<ms-checkbox
			:value="dataRow[col.dataField]"
			size="small"
			v-model="dataRow[col.dataField]"
			:disabled="
				readOnly || !editable || isDisabledItem(dataRow, col.disabledLst)
			"
			@change="changeHandler"
		/>
	</div>
</template>
<script>
import msCellInput from './msCellInput';
export default {
	name: 'MsCellCheckbox',
	extends: msCellInput,
	methods: {
		isDisabledItem(dataRow, disabledLst) {
			const me = this;
			if (!disabledLst || disabledLst.length <= 0) return false;
			let rowDisabled = disabledLst.find((x) => x == dataRow.dataField);
			return rowDisabled ? true : false;
		},

		changeHandler(value) {
			const me = this;
			let metaData = {
				dataRow: me.dataRow,
				column: me.col,
				newValue: value,
				cell: me,
			};
			me.$emit('change', metaData);
		},
	},
};
</script>
<style lang="scss" scoped>
// Căn giữa checkbox theo cột khi col.align == 'center' (Figma DS2.0: cell flex items-center justify-center)
.ms-text-center {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
}
</style>
